import React from "react";
import {
  compose,
  branch,
  renderNothing,
  renderComponent,
  mapProps,
  withHandlers,
  withProps
} from "recompose";
import { bindActionCreators } from "redux";
import { change, getFormValues } from "redux-form";
import { connect } from "react-redux";
import BaseMap from "app/map/Map";
import { computeBounds } from "app/map/utils";
import { updateMap, setMode } from "app/map/actions";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { Spinner } from "@blueprintjs/core";
import { GET } from "./constants";
import { withTmpField } from "app/proposals/hocs";
import { createHocBase, next, ids } from "app/utils";
import buildings from "app/map/rome-buildings.json";
import { dismissToast, showToast } from "app/layout/actions";
import { getURLSearch } from "app/utils";

const StyledMap = styled.div`
  height: 100%;
  position: relative;
  & .leaflet-container {
    height: 100%;
    cursor: ${props => (props.withCrosshair ? "not-allowed" : "")};
  }
  & .leaflet-container .area-of-interest {
    cursor: ${props =>
      !props.renderBuildings && props.withCrosshair ? "crosshair" : ""};
  }
  & .leaflet-container .buildings {
    cursor: ${props =>
      props.renderBuildings && props.withCrosshair ? "crosshair" : ""};
  }
  & .leaflet-interactive {
    cursor: ${props =>
      !props.renderBuildings && props.withCrosshair ? "crosshair" : ""};
  }
`;

const TopicMap = props => {
  const {
    topic,
    mode,
    setTmpLocation,
    handleObjectClick,
    selectedProposals
  } = props;
  const renderBuildings = topic._id.match(/rome/);
  return (
    <StyledMap
      withCrosshair={mode === "point" || mode === "line" || mode === "polygon"}
      renderBuildings={renderBuildings}
    >
      <BaseMap
        options={topic.config.leaflet.options}
        layersControl={topic.config.leaflet.layersControl}
        areaOfInterest={topic.areaOfInterest}
        onObjectClick={handleObjectClick}
        proposals={selectedProposals}
        onClick={setTmpLocation}
        mode={mode}
        buildings={renderBuildings && buildings}
      />
    </StyledMap>
  );
};

const UpdateError = ({ topics, topicId }) =>
  topics.actions[GET][topicId].data.message;

const withCases = compose(
  branch(({ topics, topicId }) => !topics.actions[GET][topicId], renderNothing),
  mapProps(props => {
    const { topics, topicId } = props;
    return {
      topics,
      topicId,
      [topics.actions[GET][topicId].type]: true
    };
  }),
  branch(props => props[GET.PENDING], renderComponent(Spinner)),
  branch(props => props[GET.ERROR], renderComponent(UpdateError)),
  renderNothing
);

const setTmpLocation = props => event => {
  const { feature } = event.target;
  const { mode, change, tmpField } = props;
  if (mode === "point") {
    const { lat, lng } = event.latlng;
    const point = {
      type: "Point",
      coordinates: [lng, lat]
    };
    change("proposal", `tmp.${tmpField.id}.location`, point);
    if (feature && feature.properties) {
      change("proposal", `tmp.${tmpField.id}.inputs`, {
        building: feature.properties.building,
        title: feature.properties.title
      });
    }
  }
};

const handleObjectClick = props => (
  event,
  { context: { object, proposal } }
) => {
  const { updateMap, history, topicId } = props;
  const bounds = computeBounds(object.location);
  updateMap({ bounds });
  if (proposal.ui.isTmp) {
    return;
  }
  let path = `/topics/${topicId}/p/${proposal._id}`;
  const urlSearch = getURLSearch();
  history.push(path + urlSearch);
};

const selectProposals = props => {
  const {
    topic,
    proposalId,
    proposals,
    proposalForm,
    tmpField,
    proposalList
  } = props;
  if (proposalForm) {
    let proposal = { ...proposalForm };
    if (!proposal._id) {
      proposal = { ...proposal, _id: next(ids) };
    }
    if (tmpField && tmpField.location && tmpField.location.type === "Point") {
      const content = { ...proposal.content };
      const objects = [...content.objects, tmpField];
      content.objects = objects;
      proposal.content = content;
    }
    return [proposal];
  }
  if (proposalId) {
    const proposal = proposals.proposalsById[proposalId];
    return proposal ? [proposal] : [];
  }
  if (proposalList) {
    return proposalList;
  }
  return (topic.proposals || []).map(
    proposalId => proposals.proposalsById[proposalId]
  );
};

const createMapActions = dispatch =>
  bindActionCreators(
    {
      updateMap,
      setMode,
      change,
      dismissToast,
      showToast
    },
    dispatch
  );

const selectMapState = state => {
  const {
    proposals,
    map: { mode }
  } = state;
  const proposalForm = getFormValues("proposal")(state);
  return {
    mode,
    proposals,
    proposalForm
  };
};

export default compose(
  branch(({ topic }) => !topic, withCases),
  connect(
    selectMapState,
    createMapActions
  ),
  withTmpField,
  withRouter,
  withHandlers({
    setTmpLocation,
    handleObjectClick
  }),
  Component =>
    class extends createHocBase(Component) {
      componentDidMount() {
        const { updateMap } = this.props;
        updateMap({ bounds: null });
      }
      componentDidUpdate({ proposalId, updateMap }) {
        if (proposalId && !this.props.proposalId) {
          updateMap({ bounds: null });
        }
      }
    },
  withProps(props => ({ selectedProposals: selectProposals(props) }))
)(TopicMap);



// WEBPACK FOOTER //
// ./src/app/topics/TopicMap.js